import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class FactoryRefreshedMessage extends Message {

    public item: any;

    public constructor(params: any) {
        super(params);
        this.item = this.paramOrDefault(params.item, null);
    }
}

ComponentManager.setMessage('FactoryRefreshedMessage', FactoryRefreshedMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');